import { HomeApi } from '@flipdish/api-client-typescript';

import { getApiEndPoint } from '../helpers/apibase';

const baseURL = getApiEndPoint();
const homeApi = new HomeApi(baseURL);

export const getIsOktaOnKey = 'getIsOktaOn';
export async function getIsOktaOn() {
  try {
    const result = await homeApi.getOktaPortalFeatureFlag();
    return result.body;
  } catch (incomingMessage) {
    return { Data: { OktaPortalEnabled: false } };
  }
}
